var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"bg-gray-72"},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo bg-blue-primary cl-white no-select"},[_c('span',[_vm._v("Lets")]),_vm._v(" Sites ")])
}]

export { render, staticRenderFns }